// extracted by mini-css-extract-plugin
export default {"hasSettingsDropdown":"Dishes_hasSettingsDropdown__hdOdy","tableHead":"Dishes_tableHead__Vy4WT","placeHolderShimmer":"Dishes_placeHolderShimmer__vba3P"};